import { ChevronDown } from "@assets";
import { Body } from "@components/Typography";
import "@routes/TransfersRoute/TransfersGroup/animation.css";
import { useEffect, useRef, useState } from "react";
import { styles } from "./styles";
import { TransferGroupProps } from "./types";

export const TransferGroup = ({
  icon,
  title,
  onPress,
  expanded = false,
  children,
}: TransferGroupProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      entries.forEach(() => {
        if (contentRef.current) {
          setHeight(isCollapsed ? 0 : contentRef.current.scrollHeight);
        }
      });
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [isCollapsed]);

  const toggle = () => {
    setIsCollapsed(!isCollapsed);
    onPress?.();
  };

  /* eslint-disable react-hooks/set-state-in-effect -- expand on mount */
  useEffect(() => {
    if (expanded) {
      toggle();
    }
  }, []);
  /* eslint-enable react-hooks/set-state-in-effect */

  return (
    <div className="transfer-group">
      <button className="header" onClick={toggle}>
        {icon}
        <Body className="title" style={styles.title}>
          {title}
        </Body>
        <span className={`chevron ${isCollapsed ? "" : "expanded"}`}>
          <ChevronDown size={24} />
        </span>
      </button>
      <div className="content-wrapper" style={{ height: `${height}px` }}>
        <div ref={contentRef} className="content">
          {children}
        </div>
      </div>
    </div>
  );
};
